import { UserResource } from "@clerk/types";
import React from "react";

interface BaseContextType {
    isSidebarShown: boolean,
    setIsSidebarShown: (value: boolean) => void,
    convexUserId: string,
    setConvexUserId: (value: string) => void,
    debug: boolean,
    setDebug: (value: boolean) => void,
    isAdmin: boolean,
    setIsAdmin: (value: boolean) => void,
    user: UserResource | null | undefined,
    isAuthenticationComplete: boolean,
}

export const BaseContext = React.createContext<BaseContextType>({
    isSidebarShown: false,
    setIsSidebarShown: (value: boolean) => {},
    convexUserId: '',
    setConvexUserId: (value: string) => {},
    debug: false,
    setDebug: (value: boolean) => {},
    isAdmin: false,
    setIsAdmin: (value: boolean) => {},
    user: undefined,
    isAuthenticationComplete: false,
})
